import { api } from './client';
import type { JournalEntry } from '../types';

export const journalApi = {
  list: (tripId: string) =>
    api.get<JournalEntry[]>(`/trips/${tripId}/journal`).then(r => r.data),
  create: (tripId: string, data: { dayId: string; body: string; photoIds: string[]; shared: boolean }) =>
    api.post<JournalEntry>(`/trips/${tripId}/journal`, data).then(r => r.data),
  update: (tripId: string, entryId: string, data: { body?: string; photoIds?: string[]; shared?: boolean }) =>
    api.patch<JournalEntry>(`/trips/${tripId}/journal/${entryId}`, data).then(r => r.data),
  remove: (tripId: string, entryId: string) =>
    api.delete(`/trips/${tripId}/journal/${entryId}`),
};
